"use strict"
import { getRequest, otherGetRequest, postRequest } from "@/services/RequestService";

export const getProducts = async () => {
  const base_route = `products/get-list`;
  const response = await getRequest(base_route);
  return response;
}

export const getById = async (id) => {
  const base_route = `products/${id}`;
  const response = await otherGetRequest(base_route);
  return response;
}
